var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2449 19.8867C25.6776 19.8867 26.0315 19.5578 25.9978 19.154C25.8121 16.9326 24.7864 14.8361 23.0911 13.2493C21.2104 11.489 18.6597 10.5 16 10.5C13.3403 10.5 10.7896 11.489 8.90889 13.2493C7.21358 14.8361 6.18796 16.9326 6.00223 19.154C5.96849 19.5578 6.32242 19.8867 6.75513 19.8867H9.28329C9.71599 19.8867 10.0614 19.557 10.1184 19.1555C10.2891 17.9524 10.8776 16.8273 11.8046 15.9596C12.9173 14.9182 14.4264 14.3331 16 14.3331C17.5736 14.3331 19.0827 14.9182 20.1954 15.9596C21.1223 16.8273 21.7109 17.9524 21.8816 19.1555C21.9386 19.557 22.284 19.8867 22.7167 19.8867H25.2449ZM20.5081 14.8374L21.8568 13.575C20.3947 12.3862 18.5586 11.6745 16.6268 11.5473V13.3326C18.0539 13.4521 19.4087 13.9773 20.5081 14.8374ZM15.3732 13.3326C13.9461 13.4521 12.5914 13.9773 11.4919 14.8374L10.1432 13.575C11.6053 12.3862 13.4414 11.6745 15.3732 11.5473V13.3326ZM21.3945 15.6671L22.7432 14.4047C23.9097 15.6617 24.6464 17.2142 24.8639 18.86H22.944C22.7461 17.687 22.2118 16.5825 21.3945 15.6671ZM9.25682 14.4047C8.09034 15.6617 7.35363 17.2142 7.13607 18.86H9.05598C9.25395 17.687 9.78822 16.5825 10.6055 15.6671L9.25682 14.4047Z",
    fill: "#065EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21.5C16.9519 21.5 17.7236 20.7777 17.7236 19.8867C17.7236 19.6122 17.6504 19.354 17.5213 19.1277L19.2242 17.521C19.4506 17.3073 19.4492 16.9624 19.2209 16.7504C18.9927 16.5384 18.6241 16.5398 18.3977 16.7535L16.6578 18.3949C16.4551 18.3166 16.233 18.2733 16 18.2733C15.0481 18.2733 14.2764 18.9956 14.2764 19.8867C14.2764 20.7777 15.0481 21.5 16 21.5ZM16 20.4733C16.3462 20.4733 16.6268 20.2107 16.6268 19.8867C16.6268 19.5627 16.3462 19.3 16 19.3C15.6538 19.3 15.3732 19.5627 15.3732 19.8867C15.3732 20.2107 15.6538 20.4733 16 20.4733Z",
    fill: "#065EEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmi);
export default __webpack_public_path__ + "static/media/BMI.a4ac0b87cec49cc50ddd6178501bf729.svg";
export { ForwardRef as ReactComponent };